var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"main-container"},[(_vm.isV2Route)?_c('div',{staticClass:"v2-shell"},[_c('AppShell')],1):_c('v-sheet',{staticClass:"overflow-hidden",staticStyle:{"z-index":"8"},attrs:{"color":"#f9fafc","height":"100%"}},[(
        _vm.user &&
        _vm.user.role != 'ORGANIZATION' &&
        _vm.user.role != 'HEAD_OFFICE' &&
        _vm.user.role != 'ORGANIZATION_USER' &&
        _vm.user.role != 'BRANCH' &&
        !_vm.$route.path.includes('micrositio') &&
        !_vm.$route.path.includes('checkout') &&
        !_vm.$route.path.includes('member') &&
        !_vm.$route.path.includes('matrix') &&
        !_vm.$route.path.includes('affiliation-checkout') &&
        !_vm.$route.path.includes('credential') &&
        !_vm.$route.path.includes('registro') &&
        !_vm.$route.path.includes('voucher') &&
        !_vm.$route.path.startsWith('/login') &&
        !_vm.$route.path.startsWith('/sac/leaderboard') &&
        (!_vm.$route.meta.noRedirect ||
          _vm.$route.path.includes('facturacion-cliente'))
      )?_c('landing-navbar'):_vm._e(),(
        _vm.showMainNavbar &&
        !_vm.$route.path.startsWith('/login') &&
        !_vm.$route.path.includes('micrositio') &&
        !_vm.$route.path.includes('credential') &&
        !_vm.$route.path.includes('affiliation-checkout') &&
        !_vm.$route.path.includes('registro') &&
        !_vm.$route.path.includes('voucher') &&
        !_vm.$route.meta.noRedirect
      )?_c('dashboard-navbar'):_vm._e(),(_vm.$route.path.includes('mi-evento') && !_vm.$route.meta.noRedirect)?_c('detail-navbar',{attrs:{"entityType":"Event","navigations":_vm.eventsNavigation}}):_vm._e(),(
        _vm.$route.path.includes('member') &&
        !_vm.$route.path.includes('credential') &&
        !_vm.$route.path.includes('micrositio') &&
        !_vm.$route.path.includes('affiliation-checkout') &&
        !_vm.$route.path.includes('voucher') &&
        _vm.$route.name != 'Renew Membership' &&
        _vm.$route.name != 'Member new Checkout' &&
        !_vm.$route.path.includes('affiliation-profile') &&
        !_vm.$route.meta.noRedirect
      )?_c('side-bar',{attrs:{"items":_vm.membersItems}}):_vm._e(),(
        _vm.$route.path.includes('mi-membresia') &&
        (_vm.user.role !== 'BRANCH' ||
          (_vm.branchMembershipAccessChecked && _vm.branchMembershipAccessMode))
      )?_c('detail-navbar',{attrs:{"entityType":"Affiliation","navigations":_vm.affiliationNavigationsForUser}}):_vm._e(),(
        _vm.$route.path.includes('mi-capitulo') && !_vm.$route.meta.noRedirect
      )?_c('detail-navbar',{attrs:{"entityType":"Chapter","navigations":_vm.chaptersNavigation}}):_vm._e(),(
        _vm.user.role == 'BRANCH' &&
        !_vm.$route.path.startsWith('/login') &&
        !_vm.$route.path.includes('mi-evento') &&
        !_vm.$route.path.includes('mi-membresia') &&
        !_vm.$route.meta.noRedirect
      )?_c('BranchNavbar',{attrs:{"entityType":"Chapter","navigations":_vm.chaptersNavigation}}):_vm._e(),_c('v-main',{staticClass:"bg-color secondary-container"},[(
          (_vm.$route.path === '/member/home' ||
            _vm.$route.path === '/member/home/' ||
            _vm.$route.path.startsWith('/member/home/showInfo')) &&
          _vm.user &&
          (_vm.user.role === 'MEMBER' || _vm.user.role === 'MEMBERSHIP_USER')
        )?_c('div',{staticClass:"membership-header-wrapper px-4 px-md-16 pt-2"},[_c('membership-status-header')],1):_vm._e(),_c('router-view')],1)],1),_c('div',{staticClass:"siteAlerts"},[_c('BoxAlerts',{attrs:{"loggedAccount":_vm.user}})],1),_c('CookiesAdvice'),_c('v-snackbar',{style:({ zIndex: _vm.isV2Route ? 'var(--z-toast)' : '249' }),attrs:{"width":"400","multi-line":true,"top":true,"right":true,"timeout":_vm.time,"color":_vm.color,"rounded":"xl","transition":"slide-x-reverse-transition"},model:{value:(_vm.isVisible),callback:function ($$v) {_vm.isVisible=$$v},expression:"isVisible"}},[_c('span',{staticClass:"subtitle-2 font-weight-bold"},[_vm._v(_vm._s(_vm.text))])]),_c('v-overlay',{style:({ zIndex: _vm.isV2Route ? 'var(--z-modal)' : '250' }),attrs:{"value":_vm.loaderVisible}},[_c('the-loader')],1),_c('ScrollToTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }